import React, { useEffect, useMemo, useState } from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
// import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import AnchorIcon from '@mui/icons-material/Anchor';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { PiChats, PiChatText } from "react-icons/pi";
import { BsHeart, BsHeartbreak } from 'react-icons/bs';
import { BiGift } from "react-icons/bi";
import { RiArticleLine } from "react-icons/ri";

import Chimes from './Chimes';

import './style.scss';

import { clientNetwork, profileContract, stacksApi } from '../../lib/constants';
import { currencies } from '../../lib/currency';
import axios from 'axios';
import { cvToJSON, hexToCV } from '@stacks/transactions';
import Replies from './Replies';
import Likes from './Likes';
import Dislikes from './Dislikes';
import Gifts from './Gifts';
import Attachments from './Attachments';
import NftAlbum from './NftAlbum';
import MediaPlayer from '../snackmediaplayer';
import Exhibits from './Exhibits';

const ProfileTabs = ({
  profileAddress,
  authorPrincipal,
  userSettings,
  setShowUserContractDeployModal,
  setShowWoopsModal,
  setOpenConfirmModal,
  userContractStatus,
  storageUrl,

  txId,
  setTxId,
  tx_Id,
  setTx_Id
}) => {
  const [value, setValue] = useState(0);

  const [replyOpen, setReplyOpen] = useState(false);
  const [chimes, setChimes] = useState([]);
  const [reply, setReply] = useState([]);
  const [likes, setLikes] = useState([]);
  const [disLikes, setDisLikes] = useState([]);
  const [gifts, setGifts] = useState([]);
  const [attachments, setAttachments] = useState([]);

  const [loading, setLoading] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const [offset, setOffset] = useState(0);

  const [notifyText, setNotifyText] = useState('Loading...');

  const [playList, setPlayList] = useState([]);
  const [openMediaPlayer, setOpenMediaPlayer] = useState(false);

  const [selectedChimeTx, setSelectedChimeTx] = useState(0);
  const [mediaCurrentTime, setMediaCurrentTime] = useState({ currentTime: 0, playorPaused: false, txId: '' });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  async function getEventData() {
    try {
      let response = await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/extended/v1/contract/${authorPrincipal}.${profileContract}/events?limit=10&&offset=${offset}`);
      response = response.data.results;
      if (response.length === 0) {
        setLoading(false);
        setScrolling(false);
        return;
      }
      setAttachments(response);
      response = response.map(({ tx_id, contract_log: { contract_id, value: { hex } } }) => {
        const { value } = cvToJSON(hexToCV(hex)).value.event;
        switch (value) {
          case 'send-message':
            setChimes(chimes => [...chimes, { base: tx_id, hex: hex }]);
            break;
          case 'favorable-reply-message':
          case 'unfavorable-reply-message':
            setReply(reply => [...reply, { base: tx_id, hex: hex, contractId: contract_id }]);
            break;
          case 'like-message':
            const likeTxid = cvToJSON(hexToCV(hex)).value['liked-txid'].value;
            setLikes(likes => [...likes, { liked_txid: likeTxid }]);
            break;
          case 'dislike-message':
            const dislikeTxid = cvToJSON(hexToCV(hex)).value['disliked-txid'].value;
            setDisLikes(disLikes => [...disLikes, { disLiked_txid: dislikeTxid }]);
            break;
          case 'gift-message':
            // const { amount, "chime-author": chimeAuthor, memo, "via-id": via_id, "is-stx": isStx, "contractId": contractId } = cvToJSON(hexToCV(hex)).value;
            const { amount, "chime-author": chimeAuthor, memo, "via-id": via_id, "is-stx": isStx, contractId } = cvToJSON(hexToCV(hex)).value;
            const giftObject = { via_id: via_id.value, amount: amount.value, memo: memo.value.value, chimeAuthor: chimeAuthor.value, isStx: isStx };

            if (contractId !== undefined) {
              giftObject.contractId = contractId.value;
            }

            setGifts(gifts => [...gifts, giftObject]);
            break;
          default:
            break;
        }
        setOffset(offset + 10);
        setLoading(false);
        setScrolling(false);
        return true;
      })
    } catch (error) {
      setNotifyText(error.message);
    }
  }

  useEffect(() => {
    let timer;
    const handleScrollWithTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const { scrollTop, clientHeight, scrollHeight } = document.documentElement || document.body;
        if (scrollTop + clientHeight >= scrollHeight - 2000) {
          setScrolling(true);
          getEventData();
        }
      }, 500);
    };
    window.addEventListener('scroll', handleScrollWithTimer);
    return () => {
      window.removeEventListener('scroll', handleScrollWithTimer);
      clearTimeout(timer);
    };
  }, [offset]);

  useMemo(() => {
    setLoading(true);
    getEventData();
  }, [])

  useEffect(() => {
  }, [loading, scrolling])

  return (
    <>
      <Box id="profile-tabs-box" sx={{ marginTop: '1rem', }} className="profile-tabs-box">
        <Tabs value={value} onChange={handleChange} variant="fullWidth" scrollButtons="auto" aria-label="profile tabs" TabIndicatorProps={{ style: { background: "linear-gradient(90deg, #f7931a, #6444fe)" } }}>
            <Tab style={{ color: "#ffffff", minWidth: "1%", fontSize: "1.1rem", transform: "scale(1.15)" }} icon={<PiChatText />} aria-label="chimes" sx={{ '&:hover': { backgroundColor: 'transparent' } }} />
            <Tab style={{ color: "#ffffff", minWidth: "1%", fontSize: "1.1rem", transform: "scale(1.15)" }} icon={<PiChats />} aria-label='replies' sx={{ '&:hover': { backgroundColor: 'transparent' } }} />
            <Tab style={{ color: "#ffffff", minWidth: "1%", fontSize: "1.1rem", transform: "scale(1.1)" }} icon={<BsHeart />} aria-label="likes" sx={{ '&:hover': { backgroundColor: 'transparent' } }} />
            <Tab style={{ color: "#ffffff", minWidth: "1%", fontSize: "1.1rem", transform: "scale(1.1)" }} icon={<BsHeartbreak />} aria-label="dislikes" sx={{ '&:hover': { backgroundColor: 'transparent' } }} />
            <Tab style={{ color: "#ffffff", minWidth: "1%", fontSize: "1.1rem", transform: "scale(1.15)" }} icon={<BiGift />} aria-label="gifts" sx={{ '&:hover': { backgroundColor: 'transparent' } }} />
            <Tab style={{ color: "#ffffff", minWidth: "1%", fontSize: "1.1rem", transform: "scale(.85)" }} icon={<AttachFileIcon />} aria-label="attachments" sx={{ '&:hover': { backgroundColor: 'transparent' } }} />
            <Tab style={{ color: "#ffffff", minWidth: "1%", fontSize: "1.1rem", transform: "scale(.9)" }} icon={<AnchorIcon />} aria-label="nfts" sx={{ '&:hover': { backgroundColor: 'transparent' } }} />
            <Tab style={{ color: "#ffffff", minWidth: "1%", fontSize: "1.1rem", transform: "scale(.9)" }} icon={<RiArticleLine />} aria-label="exhibits" sx={{ '&:hover': { backgroundColor: 'transparent' } }} />
            {/* <Tab style={{ color: "#ffffff", minWidth: "1%", fontSize: "1.1rem" }} icon={<RocketLaunchIcon />} aria-label="boosts" /> */}
        </Tabs>

        <TabPanel id="profile-tab-panel" value={value} index={0}>
          {/* This user created Chimes here */}
          <>
            <Chimes chimeData={chimes} setReplyOpen={setReplyOpen} replyOpen={replyOpen} authorPrincipal={authorPrincipal} userSettings={userSettings}
              playList={playList} setPlayList={setPlayList} openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
              selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}

              setShowUserContractDeployModal={setShowUserContractDeployModal}
              setShowWoopsModal={setShowWoopsModal}
              setOpenConfirmModal={setOpenConfirmModal}
              userContractStatus={userContractStatus}

              txId={txId}
              setTxId={setTxId}
              tx_Id={tx_Id}
              setTx_Id={setTx_Id}
            />
            {loading === true || (scrolling === true && <div>{notifyText}</div>)}
          </>
        </TabPanel>

        <TabPanel id="profile-tab-panel" value={value} index={1}>
          {/* This user created Replies here */}
          <Replies replyData={reply} setReplyOpen={setReplyOpen} replyOpen={replyOpen} authorPrincipal={authorPrincipal} userSettings={userSettings}
            playList={playList} setPlayList={setPlayList} openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
            selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}

            setShowUserContractDeployModal={setShowUserContractDeployModal}
            setShowWoopsModal={setShowWoopsModal}
            setOpenConfirmModal={setOpenConfirmModal}
            userContractStatus={userContractStatus}

            txId={txId}
            setTxId={setTxId}
            tx_Id={tx_Id}
            setTx_Id={setTx_Id}
          />
        </TabPanel>

        <TabPanel id="profile-tab-panel" value={value} index={2}>
          {/* This user Liked Chimes here */}
          <>
            {likes && likes.map(({ liked_txid }, i) => {
              return <Likes liked_txid={liked_txid} setReplyOpen={setReplyOpen} replyOpen={replyOpen} authorPrincipal={authorPrincipal} index={i} key={i} userSettings={userSettings}
                playList={playList} setPlayList={setPlayList} openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
                selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}

                setShowUserContractDeployModal={setShowUserContractDeployModal}
                setShowWoopsModal={setShowWoopsModal}
                setOpenConfirmModal={setOpenConfirmModal}
                userContractStatus={userContractStatus}

                txId={txId}
                setTxId={setTxId}
                tx_Id={tx_Id}
                setTx_Id={setTx_Id}
              />
            })}
            {loading === true || (scrolling === true && <div>{notifyText}</div>)}
          </>
        </TabPanel>

        <TabPanel id="profile-tab-panel" value={value} index={3}>
          {/* This user Disliked Chimes here */}
          <>
            {disLikes && disLikes.map(({ disLiked_txid }, i) => {
              return <Dislikes disLiked_txid={disLiked_txid} setReplyOpen={setReplyOpen} replyOpen={replyOpen} authorPrincipal={authorPrincipal} index={i} key={i} userSettings={userSettings}
                playList={playList} setPlayList={setPlayList} openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
                selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}

                setShowUserContractDeployModal={setShowUserContractDeployModal}
                setShowWoopsModal={setShowWoopsModal}
                setOpenConfirmModal={setOpenConfirmModal}
                userContractStatus={userContractStatus}

                txId={txId}
                setTxId={setTxId}
                tx_Id={tx_Id}
                setTx_Id={setTx_Id}
              />
            })}
            {loading === true || (scrolling === true && <div>{notifyText}</div>)}
          </>
        </TabPanel>

        <TabPanel id="profile-tab-panel" value={value} index={4}>
          {/* This user Gifts Sent here */}
          {gifts && gifts.map((gift, i) => {
            return <Gifts giftsData={gift} key={i} currencies={currencies} userSettings={userSettings} />
          })}
        </TabPanel>
        <TabPanel id="profile-tab-panel" value={value} index={5}>
          {/* This user created Chimes, w/ attachments only here */}
          <Attachments attachmentData={attachments} setReplyOpen={setReplyOpen} replyOpen={replyOpen} authorPrincipal={authorPrincipal} userSettings={userSettings}
            playList={playList} setPlayList={setPlayList} openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
            selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}

            setShowUserContractDeployModal={setShowUserContractDeployModal}
            setShowWoopsModal={setShowWoopsModal}
            setOpenConfirmModal={setOpenConfirmModal}
            userContractStatus={userContractStatus}

            txId={txId}
            setTxId={setTxId}
            tx_Id={tx_Id}
            setTx_Id={setTx_Id}
          />
        </TabPanel>
        <TabPanel id="profile-tab-panel" value={value} index={6}>
          {/* This user owned and supported NFTs here */}
          <NftAlbum authorPrincipal={authorPrincipal} userSettings={userSettings} />
        </TabPanel>

        <TabPanel id="profile-tab-panel" value={value} index={7}>
          {/* This user created Exhibits here */}
          <Exhibits
            setShowUserContractDeployModal={setShowUserContractDeployModal}
            setShowWoopsModal={setShowWoopsModal}
            setOpenConfirmModal={setOpenConfirmModal}
            userContractStatus={userContractStatus}
            storageUrl={storageUrl}
            profileAddress={profileAddress}

            txId={txId}
            setTxId={setTxId}
            tx_Id={tx_Id}
            setTx_Id={setTx_Id}
          />
        </TabPanel>

        {/* <TabPanel id="profile-tab-panel" value={value} index={7}>
        <Typography variant="h5">Boosts</Typography>
      </TabPanel> */}
      </Box>

      {(openMediaPlayer && playList.length > 0) ? <MediaPlayer openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer} playList={playList} setPlayList={setPlayList} selectedChimeTx={selectedChimeTx} setMediaCurrentTime={setMediaCurrentTime} setSelectedChimeTx={setSelectedChimeTx}
        setShowUserContractDeployModal={setShowUserContractDeployModal}
        setShowWoopsModal={setShowWoopsModal}
        setOpenConfirmModal={setOpenConfirmModal}
        userContractStatus={userContractStatus}
        setReplyOpen={setReplyOpen}
        txId={txId}
        setTxId={setTxId}
        tx_Id={tx_Id}
        setTx_Id={setTx_Id}
      /> : null}

    </>
  );
};

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box >
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export default ProfileTabs;